import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { type CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { CloseButtonComponent } from '@modules/common/components/controls/app-close-button.component';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { Subject } from 'rxjs';
import { BigEventsPreviewListComponent } from './big-events-preview-list.component';

@Component({
  selector: 'stch-events-list-popup',
  templateUrl: './events-list-popup.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BigEventsPreviewListComponent, DateFormatPipe, CloseButtonComponent],
})
export class EventsListPopupComponent {
  public readonly date = input.required<Date>();
  public readonly events = input.required<CalendarEvent[]>();
  readonly popoverClose = input.required<Subject<void>>();
  protected readonly eventClicked = output<CalendarEvent>();
  protected readonly eventDblClicked = output<CalendarEvent>();

  public handleClosePopover() {
    this.popoverClose().next();
  }
}
